import { css } from '@emotion/react'
import { Theme } from '@mui/material'
import { isPropertyExposedLegend } from '@app/components/Property/utils/isPropertyExposedLegend'

export const tabParent = (theme: Theme, selectedAssetInfoIsLoading: boolean) => css`
  height: 100%;
  max-height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  color: ${theme.palette.uintel.main};
  font-size: 14px;
  opacity: ${selectedAssetInfoIsLoading ? 0.5 : 1};
  transition: opacity 0.2s ease-in-out;

  h2 {
    font-size: 20px;
    font-weight: 500;
    line-height: 14px;
    margin-bottom: 12px;
  }

  h3 {
    padding-top: 10px;
    font-size: 14px;
    font-weight: 700;
    line-height: 130%;
  }

  h4 {
    padding: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 130%;
    color: ${theme.palette.uintel.main};
  }

  ul {
    margin-left: 24px;
  }
`

export const scrollContainer = () => css`
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow-y: auto;
`

export const noDetailsStyle = css`
  color: #6b7280; /* fallback for theme.text.secondary */
`

export const hazardColorDot = ({ is_exposed }: { is_exposed: 'true' | 'false' | 'unknown' }) => css`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  border-radius: 50%;
  transition: background-color 0.2s ease-in-out;
  background-color: ${isPropertyExposedLegend[is_exposed || 'unknown'].color || '#868E96'};
`

export const footerLegend = css`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  font-size: 14px;
  color: #000;

  > * {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }
`
